exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-buttons .btn {\n  margin-right: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalLogout/modalLogout.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalLogout/modalLogout.scss
// module chunks = 11